const getProductsFromSectionRenderingAPI = async (selectedFilters, selectedSort, pagination) => {
  var _a;
  let url = window.location.href.split("?")[0];
  if (window.themeVars.store.template === "list-collections") {
    url = window.location.href.replace("collections", "collections/all");
  }
  const response = await fetch(
    url + convertRequestToQueryString(selectedFilters, selectedSort, pagination)
  );
  let sectionId = "#CollectionData";
  if (window.location.pathname.includes("/search")) {
    sectionId = "#SearchData";
  }
  const text = await response.text();
  const section = new DOMParser().parseFromString(text, "text/xml");
  const collectionDataString = (_a = section.querySelector(sectionId)) == null ? void 0 : _a.innerHTML;
  const collectionData = JSON.parse(collectionDataString || "");
  return convertResponseFromSectionRenderingAPI(collectionData);
};
const convertRequestToQueryString = (selectedFilters, selectedSort, pagination) => {
  let queryString = "?";
  let sectionId = "collection-data";
  if (window.location.pathname.includes("/search")) {
    const searchParams = new URLSearchParams(window.location.search);
    const searchQuery = searchParams.get("q") || "";
    const typeQuery = searchParams.get("type") || "";
    sectionId = "search-data";
    queryString = `?q=${searchQuery}&type=${typeQuery}&`;
  }
  selectedFilters.forEach((filter) => {
    const encodedValues = filter.values.map((value) => encodeURI(value));
    queryString += `${filter.param_name}=${encodedValues}&`;
  });
  queryString += selectedSort ? `sort_by=${selectedSort}&` : "";
  queryString += pagination.currentPage ? `page=${pagination.currentPage}&` : "";
  queryString += `section_id=${sectionId}`;
  return queryString;
};
const convertResponseFromSectionRenderingAPI = (response) => response;
export {
  getProductsFromSectionRenderingAPI as g
};
